import { ContentType, IContent } from 'types';

export const getTypeText = (type: IContent['type']) => {
  switch (type) {
    case ContentType.INTERNAL:
      return '상세페이지';
    case ContentType.EXTERNAL:
      return '외부페이지';
    case ContentType.YOUTUBE:
      return 'youtube';
    case ContentType.INSTAGRAM:
      return 'instagram';
    case ContentType.NONE:
      return '설정안함';
    case ContentType.EVENT_DETAIL:
      return '봉사 상세';
    default:
      return '';
  }
};
